import { SearchAdapter, SearchRequest } from '@empathy/search-adapter';
import { container } from '../../../container';
import { DEPENDENCIES } from '../../../container/dependencies.const';
import { SearchState } from '../../../models';
import { arrayToObject, catchAdapterError, mapWishlistToResults } from '../../../utils';
import { SEARCH_ACTIONS_KEYS, SEARCH_GETTERS_KEYS } from '../search.const';
import { SearchAction, SearchContext } from '../search.interfaces';

export class DispatchSearchAction implements SearchAction {
  actions = {
    [SEARCH_ACTIONS_KEYS.search]: (context: SearchContext, searchRequest?: SearchRequest): Promise<Partial<SearchState>> =>
      this.doSearch(context, searchRequest)
  };

  private doSearch(context: SearchContext, searchRequest: SearchRequest = context.getters[SEARCH_GETTERS_KEYS.searchRequest])
    : Promise<Partial<SearchState>> {
    const { wishlist } = context.rootState.core;
    const platformAdapter: SearchAdapter = container.get<SearchAdapter>(DEPENDENCIES.Adapter);
    return platformAdapter.search(searchRequest)
      .then(({ totalResults, facets, redirections, ...rest }) => {
        mapWishlistToResults(wishlist, rest.results);
        return {
          numFound: totalResults,
          facets: arrayToObject(facets, 'modelName'),
          directs: redirections,
          ...rest
        } as Partial<SearchState>;
      })
      .catch(catchAdapterError('Search'));
  }
}
